export default "__VITE_ASSET__BDmb6Iz7__"